import axios from "axios";
import { takeLatest, put } from "redux-saga/effects";

import { API_BASE_URI } from "../ApiCall";
import { SubContractPlanActionTypes } from "./SubContractPlan.type";

export function* fetchAllSubContractPlans(action: any): any {
  try {
    const response = yield axios.get(
      `${API_BASE_URI}/sub_contract_plan?project_id=${action.payload.project_id}&date_type=${action.payload.date_type}&date=${action.payload.date}`
    );
    yield put({
      type: SubContractPlanActionTypes.FETCH_ALL_SUB_CONTRACT_PLAN_SUCCESS,
      payload: response.data,
    });
  } catch (error) {
    yield put({
      type: SubContractPlanActionTypes.FETCH_ALL_SUB_CONTRACT_PLAN_FAILURE,
      payload: error,
    });
  }
}

export function* watcherFetchAllSubContractPlans() {
  yield takeLatest(
    SubContractPlanActionTypes.FETCH_ALL_SUB_CONTRACT_PLAN,
    fetchAllSubContractPlans
  );
}
